import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { DeliverablesSection } from '../components/DeliverablesSection';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
export function LandingPage() {
  return <main className="w-full min-h-screen overflow-x-hidden" style={{
    backgroundColor: 'var(--color-navy)'
  }} data-id="element-342">
      <HeroSection data-id="element-343" />
      <ProblemSection data-id="element-344" />
      <MechanismSection data-id="element-345" />
      <DeliverablesSection data-id="element-346" />
      <HowItWorksSection data-id="element-347" />
      <AudienceSection data-id="element-348" />
      <ProofSection data-id="element-349" />
      <FAQSection data-id="element-350" />
      <OfferSection data-id="element-351" />
    </main>;
}